export default __webpack_public_path__ + "static/media/apple-touch-icon.f7168e7d.png";